module.exports = __webpack_public_path__ + "img/voet.d9148f31.webp";